import {
  Box,
  Columns,
  Container,
  Heading,
  Stack,
  Text,
} from '@spaceship-fspl/components';
import { match, width } from '@spaceship-fspl/styles';
import { TrackingCategory } from '@spaceship-fspl/tracking';
import { PanelSection } from 'components';
import React from 'react';
import styled from 'styled-components';

import bgImage from './img-portfolio-earth.svg';

const BG_IMAGE_HEIGHT = 762;
const BG_IMAGE_WIDTH = 678;
const BG_IMAGE_WIDTH_XS = '100vw';
const BG_IMAGE_HEIGHT_XS = `calc(${BG_IMAGE_HEIGHT} / ${BG_IMAGE_WIDTH} * ${BG_IMAGE_WIDTH_XS})`;

const BackgroundImage = styled.div`
  ${width({
    xs: BG_IMAGE_WIDTH_XS,
    md: BG_IMAGE_WIDTH * 0.58,
    lg: BG_IMAGE_WIDTH,
  })}
  background: url(${bgImage}) no-repeat;
  background-position: center;
  background-size: cover;
  height: 100%;
  left: 50%;
  pointer-events: none;
  position: absolute;
  top: 0;
  transform: translateX(-50%);

  ${match('md')`
    left: auto;
    right: 0;
    transform: none;
  `}
`;

export interface PortfolioDescriptionPanelProps {
  title: string | React.ReactNode;
  tagline: string | React.ReactNode;
}

export const PortfolioDescriptionPanel: React.FC<
  React.PropsWithChildren<PortfolioDescriptionPanelProps>
> = ({ title, tagline }) => (
  <TrackingCategory category="Portfolio Description Panel">
    <PanelSection>
      <Container>
        <Columns
          alignY="center"
          spaceX={{ md: 'md', lg: 'xxl' }}
          spaceY={{ xs: 'lg', md: 'none' }}
        >
          <Columns.Column width={{ xs: 1, md: 1 / 2 }}>
            <Box
              height={{
                xs: BG_IMAGE_HEIGHT_XS,
                md: BG_IMAGE_HEIGHT * 0.58,
                lg: BG_IMAGE_HEIGHT,
              }}
              position="relative"
            >
              <BackgroundImage />
            </Box>
          </Columns.Column>

          <Columns.Column width={{ xs: 1, md: 1 / 2, lg: 5 / 12 }}>
            <Stack spaceY="sm">
              <Heading component="h2" variant={2} color="neutral.100">
                {title}
              </Heading>

              <Text variant={1} color="neutral.085" component="div">
                {tagline}
              </Text>
            </Stack>
          </Columns.Column>
        </Columns>
      </Container>
    </PanelSection>
  </TrackingCategory>
);
